export default __webpack_public_path__ + "static/media/FSIndustrieCd-Light.9980844f.ttf";